var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-treeview-container"},_vm._l((_vm.items),function(node){return _c('ed-tree-node',{key:node[_vm.itemKey],attrs:{"node":node,"item-key":_vm.itemKey,"open":_vm.open},on:{"update:open":function($event){_vm.open=$event}},scopedSlots:_vm._u([{key:"prepend",fn:function(ref){
var item = ref.item;
var open = ref.open;
return [_vm._t("prepend",null,{"item":item,"open":open})]}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }